<template>
  <div class="frisbuy-picture-sticker">
    <img :src="sticker.pictureUrl" />
  </div>
</template>

<style scoped lang="scss">
.frisbuy-picture-sticker {
  pointer-events: none;

  width: 100% !important;

  & > img {
    width: 100%;
  }
}
</style>

<script>
export default {
  props: {
    sticker: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {};
  },
};
</script>
